export const USUARIO_LOADING = "USUARIO_LOADING";
export const USUARIO_SET_USER = "USUARIO_SET_USER";
export const USUARIO_SET_EMPRESAS = "USUARIO_SET_EMPRESAS";
export const USUARIO_SET_EMPRESA_ATUAL = "USUARIO_SET_EMPRESA_ATUAL";
export const USUARIO_SET_SELECT_EMPRESA = "USUARIO_SET_SELECT_EMPRESA";
export const USUARIO_SET_PERMISSOES = "USUARIO_SET_PERMISSOES";
